import axios from "axios";
import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type PaginatinProps = {
  page: string | null;
  total: number;
};

export function EmagPagination(props: PaginatinProps) {
  const {page, total} = props
  let [searchParams, setSearchParams] = useSearchParams();
  const currentPage = page ? parseInt(page, 10): 1
  let totalPage = Math.ceil(total/10)
  const range = Array.from(Array(totalPage).keys())

  const handlePrev = () => {
    if (currentPage === 1) return;
    setSearchParams({
      page: `${currentPage - 1}`
    })
  }

  const handleNext = () => {
    if (currentPage >= totalPage) return;
    setSearchParams({
      page: `${currentPage + 1}`
    })
  }

  const handlePageClick = (toPage:number) => {
    if (currentPage === toPage) return;

    setSearchParams({
      page: `${toPage}`
    })
  }
  return (
    <>
      <div className="pagination">
        <button className="prev" onClick={handlePrev}>
          <img src="/ondemand/static/img/p-prev.png" alt="" />
        </button>
        {range.map((p) => {
          const cls = classNames({'active': p +1 === currentPage})
          return (
            <button onClick={() => {handlePageClick(p+1)}} className={cls}>{p + 1}</button>
          )
        })}
        <button className="next" onClick={handleNext}>
          <img src="/ondemand/static/img/p-next.png" alt="" />
        </button>
      </div>
    </>
  );
}


export function SubcategoryPagination(props: PaginatinProps) {
  const {page, total} = props
  let [searchParams, setSearchParams] = useSearchParams();
  const currentPage = page ? parseInt(page, 10): 1
  let totalPage = Math.ceil(total/28)
  const range = Array.from(Array(totalPage).keys())

  const handlePrev = () => {
    if (currentPage === 1) return;
    setSearchParams({
      page: `${currentPage - 1}`
    })
  }

  const handleNext = () => {
    if (currentPage >= totalPage) return;
    setSearchParams({
      page: `${currentPage + 1}`
    })
  }

  const handlePageClick = (toPage:number) => {
    if (currentPage === toPage) return;

    setSearchParams({
      page: `${toPage}`
    })
  }
  return (
    <>
      <div className="pagination">
        <button className="prev" onClick={handlePrev}>
          <img src="/ondemand/static/img/p-prev.png" alt="" />
        </button>
        {range.map((p) => {
          const cls = classNames({'active': p +1 === currentPage})
          return (
            <button onClick={() => {handlePageClick(p+1)}} className={cls}>{p + 1}</button>
          )
        })}
        <button className="next" onClick={handleNext}>
          <img src="/ondemand/static/img/p-next.png" alt="" />
        </button>
      </div>
    </>
  );
}